<div class="dialog coach-picker-dialog">
  <div class="dialog-header">
    <h3>{{ 'COACH_LIST' | translate }}</h3>
    <span class="flex"></span>
    <a class="reset-btn" (click)="reset()"><img src="./assets/img/undo.svg"></a>
  </div>
  <div class="dialog-body">
    <ng-scrollbar class="htz-scrollbar"
                  style="width: 100%;"
                  [track]="'vertical'"
                  [visibility]="'hover'">
      <div class="coach-list">
        <div class="coach-list-item"
             [ngClass]="{'active': getSelectionPos(coach.id) >= 0}"
             (click)="toggleSelection(coach)"
             *ngFor="let coach of planningCoachList">
          <img src="{{coach.photo | apiasset | defaultAsset:'DEFAULT_AVATAR'}}"> {{coach.fullName}}
        </div>
      </div>
    </ng-scrollbar>
  </div>
  <div class="dialog-actions">
    <button class="dialog-btn dialog-btn-fill--primary"
            (click)="applySelection()">{{'LBL_CONFIRM' | translate}}</button>
    <button class="dialog-btn" (click)="close()">{{'CANCEL' | translate}}</button>
  </div>
</div>

